import Input from "../../../common/Input";

const PersonalInfo = ({
  formik,
  isEdit,
  handleEditIconClick,
  handleBlur,
  editingField,
  isDisabled,
}) => {
  const { values, handleChange, touched, errors, setFieldTouched } = formik;
  return (
    <div className="mb-3">
      <div className="grid grid-cols-12 gap-[8px]">
        <div className="col-span-12 lg:col-span-6">
          <h2 className="text-black-lose text-[13px] font-medium mb-2">
            Personal info
          </h2>
          <div className="grid grid-cols-12 gap-[8px]">
            <div className="col-span-12 md:col-span-6">
              <Input
                placeholder="Enter"
                inputBox="mb-0"
                type="text"
                inputMain="pb-[20px] relative"
                labelName="Name*"
                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                name="personalInfo.name"
                id="personalInfo.name"
                value={values?.personalInfo?.name}
                onChange={handleChange}
                isError={
                  touched?.personalInfo?.name &&
                  Boolean(errors?.personalInfo?.name)
                }
                errorMessage={errors?.personalInfo?.name}
                disabled={isDisabled && editingField !== "personalInfo.name"}
                showEditIcon={isEdit}
                onBlur={() =>
                  handleBlur ? handleBlur("personalInfo.name") : ""
                }
                onEditClick={() => handleEditIconClick("personalInfo.name")}
                disabledClass="bg-primary-50 border-primary-50 "
              />
            </div>
            <div className="col-span-12 md:col-span-6">
              <Input
                placeholder="Enter"
                inputBox="mb-0"
                type="text"
                labelName="Surname*"
                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                name="personalInfo.surname"
                id="personalInfo.surname"
                value={values.personalInfo.surname}
                onChange={handleChange}
                isError={
                  touched?.personalInfo?.surname &&
                  Boolean(errors?.personalInfo?.surname)
                }
                errorMessage={errors?.personalInfo?.surname}
                disabled={isDisabled && editingField !== "personalInfo.surname"}
                showEditIcon={isEdit}
                onBlur={() =>
                  handleBlur ? handleBlur("personalInfo.surname") : ""
                }
                onEditClick={() => handleEditIconClick("personalInfo.surname")}
                disabledClass="bg-primary-50 border-primary-50 "
              />
            </div>
            <div className="col-span-12 md:col-span-6">
              <Input
                placeholder="Enter"
                inputBox="mb-0"
                type="textarea"
                labelName="Qualification/Specialisation*"
                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full whitespace-pre-wrap"
                name="personalInfo.qualificationSpecialisation"
                id="personalInfo.qualificationSpecialisation"
                value={values.personalInfo.qualificationSpecialisation}
                onChange={handleChange}
                isError={
                  touched?.personalInfo?.qualificationSpecialisation &&
                  Boolean(errors?.personalInfo?.qualificationSpecialisation)
                }
                errorMessage={errors?.personalInfo?.qualificationSpecialisation}
                disabled={
                  isDisabled &&
                  editingField !== "personalInfo.qualificationSpecialisation"
                }
                showEditIcon={isEdit}
                onBlur={() =>
                  handleBlur
                    ? handleBlur("personalInfo.qualificationSpecialisation")
                    : ""
                }
                onEditClick={() =>
                  handleEditIconClick(
                    "personalInfo.qualificationSpecialisation"
                  )
                }
                disabledClass="bg-primary-50 border-primary-50 "
              />
            </div>
            <div className="col-span-12 md:col-span-6">
              <Input
                placeholder="Enter"
                inputBox="mb-0"
                type="number"
                labelName="Experience (Years)*"
                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                className="border-none bg-transparent [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                name="personalInfo.experience"
                id="personalInfo.experience"
                value={values?.personalInfo?.experience}
                onChange={(e) => {
                  handleChange(e);
                  setFieldTouched("personalInfo.experience", true, false);
                }}
                isError={
                  touched?.personalInfo?.experience &&
                  Boolean(errors?.personalInfo?.experience)
                }
                errorMessage={errors?.personalInfo?.experience}
                disabled={
                  isDisabled && editingField !== "personalInfo.experience"
                }
                showEditIcon={isEdit}
                onBlur={() =>
                  handleBlur ? handleBlur("personalInfo.experience") : ""
                }
                onEditClick={() =>
                  handleEditIconClick("personalInfo.experience")
                }
                disabledClass="bg-primary-50 border-primary-50 "
              />
            </div>

            <div className="col-span-12">
              <Input
                placeholder="Enter"
                inputBox="mb-0"
                type="text"
                labelName="About (max. 120 words)"
                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                name="personalInfo.about1"
                id="personalInfo.about1"
                value={values.personalInfo.about1}
                onChange={(e) => {
                  handleChange(e);
                  setFieldTouched("personalInfo.about1", true, false);
                }}
                isError={
                  touched?.personalInfo?.about1 &&
                  Boolean(errors?.personalInfo?.about1)
                }
                errorMessage={errors?.personalInfo?.about1}
                disabled={isDisabled && editingField !== "personalInfo.about1"}
                showEditIcon={isEdit}
                onBlur={() =>
                  handleBlur ? handleBlur("personalInfo.about1") : ""
                }
                onEditClick={() => handleEditIconClick("personalInfo.about1")}
                disabledClass="bg-primary-50 border-primary-50 "
              />
            </div>
          </div>
        </div>
        <div className="col-span-12 lg:col-span-6">
          <h2 className="text-black-lose text-[13px] font-medium mb-2">
            Clinic Info
          </h2>
          <div className="grid grid-cols-12 gap-[8px]">
            <div className="col-span-12 md:col-span-6">
              <Input
                placeholder="Enter"
                inputBox="mb-0"
                type="text"
                labelName="Clinic Name*"
                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                name="personalInfo.clinicName"
                id="personalInfo.clinicName"
                value={values?.personalInfo?.clinicName}
                onChange={handleChange}
                isError={
                  touched?.personalInfo?.clinicName &&
                  Boolean(errors?.personalInfo?.clinicName)
                }
                errorMessage={errors?.personalInfo?.clinicName}
                disabled={
                  isDisabled && editingField !== "personalInfo.clinicName"
                }
                showEditIcon={isEdit}
                onBlur={() =>
                  handleBlur ? handleBlur("personalInfo.clinicName") : ""
                }
                onEditClick={() =>
                  handleEditIconClick("personalInfo.clinicName")
                }
                disabledClass="bg-primary-50 border-primary-50 "
              />
            </div>
            <div className="col-span-12 md:col-span-6">
              <Input
                placeholder="Enter"
                inputBox="mb-0"
                type="text"
                labelName="Tagline"
                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                name="personalInfo.tagline"
                id="personalInfo.tagline"
                value={values.personalInfo.tagline}
                onChange={handleChange}
                disabled={isDisabled && editingField !== "personalInfo.tagline"}
                showEditIcon={isEdit}
                onBlur={() =>
                  handleBlur ? handleBlur("personalInfo.tagline") : ""
                }
                onEditClick={() => handleEditIconClick("personalInfo.tagline")}
                disabledClass="bg-primary-50 border-primary-50 "
              />
            </div>
            <div className="col-span-12 md:col-span-6">
              <Input
                placeholder="Enter"
                inputBox="mb-0"
                type="text"
                labelName="Operator Name"
                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                name="personalInfo.operatorName"
                id="personalInfo.operatorName"
                value={values.personalInfo.operatorName}
                onChange={handleChange}
                disabled={
                  isDisabled && editingField !== "personalInfo.operatorName"
                }
                showEditIcon={isEdit}
                onBlur={() =>
                  handleBlur ? handleBlur("personalInfo.operatorName") : ""
                }
                onEditClick={() =>
                  handleEditIconClick("personalInfo.operatorName")
                }
                disabledClass="bg-primary-50 border-primary-50 "
              />
            </div>
            <div className="col-span-12 md:col-span-6">
              <Input
                placeholder="Enter"
                inputBox="mb-0"
                type="text"
                labelName="Manager Name"
                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                name="personalInfo.managerName"
                id="personalInfo.managerName"
                value={values.personalInfo.managerName}
                onChange={handleChange}
                disabled={
                  isDisabled && editingField !== "personalInfo.managerName"
                }
                showEditIcon={isEdit}
                onBlur={() =>
                  handleBlur ? handleBlur("personalInfo.managerName") : ""
                }
                onEditClick={() =>
                  handleEditIconClick("personalInfo.managerName")
                }
                disabledClass="bg-primary-50 border-primary-50 "
              />
            </div>
            <div className="col-span-12">
              <Input
                placeholder="Enter"
                inputBox="mb-0"
                type="text"
                labelName="About (max. 120 words)"
                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                name="personalInfo.about2"
                id="personalInfo.about2"
                value={values.personalInfo.about2}
                onChange={(e) => {
                  handleChange(e);
                  setFieldTouched("personalInfo.about2", true, false);
                }}
                isError={
                  touched?.personalInfo?.about2 &&
                  Boolean(errors?.personalInfo?.about2)
                }
                errorMessage={errors?.personalInfo?.about2}
                disabled={isDisabled && editingField !== "personalInfo.about2"}
                showEditIcon={isEdit}
                onBlur={() =>
                  handleBlur ? handleBlur("personalInfo.about2") : ""
                }
                onEditClick={() => handleEditIconClick("personalInfo.about2")}
                disabledClass="bg-primary-50 border-primary-50 "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalInfo;
